

export const financialPieOption = {
    switchTheme:true,
    width: '100%',
    height: 600,
    title: '手机大比拼',
    subtitle: '纯属虚构',
    labelShow:true,
    radius: true,
    "barColor": [
      {
        "color1": "#83bff6",
      },
      {
        "color1": "#23B7E5",
      },
      {
        "color1": "rgba(154, 168, 212, 1)",
      },
      {
        "color1": "#188df0",
      },
      {
        "color1": "#564AA3",
      }
    ]
  }